'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'PARAGRAPH_01',
	name: 'Paragraph',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Text',
	props: [{
		name: 'text',
		inputType: 'hidden',
		default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus maximus suscipit aliquam.'
	}, {
		name: 'editable',
		inputType: 'hidden',
		default: true
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};